import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "src/auth/AuthContext";
import LoginPage from "src/pages/Authentication";
import SubscriptionLockedPage from "src/pages/SubscriptionLockedPage";
import { useAppSelector } from "src/redux/hooks";
import { getAuthState } from "src/redux/slices/authSlice";

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const auth = useAuth();
  const { isAuthenticated, isSubscriptionLocked, overdueAmount, overduePeriodDays, currency, currencySymbol, clientId } = useAppSelector(getAuthState);
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <LoginPage />;
  }

  if (isSubscriptionLocked) {
    return (
      <SubscriptionLockedPage
        clientId={Number(clientId)}
        overdueAmount={Number(overdueAmount)}
        overduePeriodDays={Number(overduePeriodDays)}
        currency={currency || "USD"}
        currencySymbol={currencySymbol || "$"}
        onLogout={() => auth.signOut()}
      />
    );
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

export default AuthGuard;
